import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, Event, NavigationEnd } from '@angular/router';
import { takeUntil } from 'rxjs/operators';

import { TopMenuService } from '../../../../app/content/menu.service';
import { AccountService } from '../../../../app/entry/account.service';
import { AutoUnsubscribeComponent } from 'app/content/virtual/auto-unsubscribe.component';

enum ReportTabType {
    records = 'records',
    config = 'config',
}

@Component({
    templateUrl: './report-wrapper.component.html',
    styleUrls: [],
    standalone: false
})
export class ReportWrapperComponent extends AutoUnsubscribeComponent implements OnInit {
    _reportListRoute: string;
    _reportConfigRoute: string;

    _activeTab: ReportTabType = ReportTabType.config;
    _enumReportTabType: typeof ReportTabType = ReportTabType;

    constructor(
        private location: Location,
        private router: Router,
        private acocuntSvc: AccountService,
        private menuSvc: TopMenuService) {
            super();
    }

    ngOnInit(): void {
        this._reportConfigRoute = this.menuSvc.getReportRoute(ReportTabType.config);
        this._reportListRoute = this.menuSvc.getReportRoute(ReportTabType.records);

        this.router.events.pipe(
            takeUntil(this._unsubscribe$)
        ).subscribe((routeEvent: Event) => {
            if (routeEvent instanceof NavigationEnd) {
                this.update_active_route(this.location.path());
            }
        });

        this.update_active_route(this.location.path());
    }

    supportReportView(): boolean {
        return this.acocuntSvc.hasScope_weeklyReport_view();
    }

    supportReportUpdate(): boolean {
        return this.acocuntSvc.hasScope_weeklyReport_update();
    }

    private update_active_route(route: string): void {
        const route_pieces: string[] = this.location.path().split(/\//g);
        if (!ReportTabType[route_pieces[route_pieces.length - 1]]) {
            this.router.navigate([this.menuSvc.getReportRoute(ReportTabType.records)]);
        }
        else {
            this._activeTab = ReportTabType[route_pieces[route_pieces.length - 1]];
        }
    }
}